import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  :root {
    --primary: #00b4d8;
    --dark: #03045e;
    --white: #ffffff;
    --bg: #f8faff;
  }

  * { margin: 0; padding: 0; box-sizing: border-box; }
  html { scroll-behavior: smooth; overflow-x: hidden; }

  body {
    font-family: 'Inter', sans-serif;
    background: #ffffff;
    color: #03045e;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }

  a { text-decoration: none; color: inherit; }
  img { max-width: 100%; height: auto; }
  button { cursor: pointer; font-family: 'Inter', sans-serif; }

  .info-link {
    display: block;
    width: fit-content;
    margin: 20px auto;
    padding: 13px 28px;
    background: #00b4d8;
    color: #03045e;
    border-radius: 4px;
    font-weight: 800;
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    transition: all 0.25s ease;
  }

  .info-link:hover { background: #90e0ef; transform: translateY(-2px); }
  .info-link .arrow-icon { stroke: #03045e; transition: transform 0.3s ease; }
  .info-link:hover .arrow-icon { transform: translateX(5px); }

  ::-webkit-scrollbar { width: 5px; }
  ::-webkit-scrollbar-track { background: #f8faff; }
  ::-webkit-scrollbar-thumb { background: #00b4d8; border-radius: 3px; }
`;

export default GlobalStyles;
